import React from "react";

import { isEnabled } from "utils/featureFlags";

import { Icon } from "aible";

import giftIcon from "images/gift-light.svg";

import styles from "./style.module.css";

const WARNING_KEY = "aible_server_warning";

const emailSubject = encodeURI("Server Migration Questions");
const emailBody = encodeURI("I have some questions regarding recreating my existing projects on the new Aible Server.");
const emailAddress = "success@aible.com";

const MESSAGE_TYPES = {
  NONE: "NONE",
  PREVIEW: "PREVIEW",
  LAST: "LAST",
  PROD: "PROD",
  NEXT: "NEXT"
};

const CURR_MESSAGE_TYPE = MESSAGE_TYPES.PROD;

export default class ServerWarning extends React.Component {
  constructor(props) {
    super(props);
    // props.removeItem(WARNING_KEY)

    const savedHidden = props.getItem(WARNING_KEY);

    this.state = {
      isHidden: Boolean(savedHidden),
      neverShow: false
    };
  }

  handleClose() {
    const { storeItem } = this.props;
    if (this.state.neverShow) {
      storeItem(WARNING_KEY, true);
    }
    return this.setState({ isHidden: true });
  }

  renderFooter() {
    return (
      <div className={styles.warningFooter}>
        <input
          type="checkbox"
          style={{ marginBottom: "3px" }}
          checked={this.state.neverShow}
          onChange={() => {
            this.setState({ neverShow: !this.state.neverShow });
          }}
        />
        <div className={styles.warningFooterContent}>{"Don't show this again."}</div>
      </div>
    );
  }

  renderPREVIEW() {
    return (
      <div className={styles.warningWrapper} style={{ backgroundColor: "#E6E6FC" }}>
        <div className={styles.warning}>
          <div className={styles.warningHeader}>
            <Icon src={giftIcon} />
            <div className={styles.warningTitle}>{"New Features Coming Soon to Aible"}</div>
            <a className={styles.warningButton} onClick={() => this.handleClose()}>
              X
            </a>
          </div>
          <div className={styles.warningBody}>
            <div className={styles.warningContent}>
              <span>
                {
                  "Aible will be introducing updates to our product portfolio with tons of brand new features. As an existing customer, you will get all of the relevant features at no additional cost. Please stay tuned for upcoming information on how to take advantage of the latest suite of features. Our customer success team will reach out soon, and until then please feel free to reach out to "
                }
              </span>
              <a href={`mailto:info@aible.com`}>info@aible.com</a>
              <span>{" with any questions."}</span>
            </div>
            <div className={styles.warningContent}>
              <span>
                {
                  "The latest update to Aible includes many new features and brand new products - Sense, Explore, and Optimize. Existing customers get all of the relevant features at no additional costs, but this big shift requires you to conduct a one-time migration to set up. This migration should take no more than an hour and our customer success team will work closely with you to help."
                }
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderLAST() {
    return (
      <div className={styles.warningWrapper}>
        <div className={styles.warning}>
          <div className={styles.warningHeader}>
            <Icon type="warning" />
            <div className={styles.warningTitle}>
              {"This is a deprecated server that will no longer receive updates"}
            </div>
            <a className={styles.warningButton} onClick={() => this.handleClose()}>
              X
            </a>
          </div>
          <div className={styles.warningBody}>
            <div className={styles.warningContent}>
              <span>{"Please use "}</span>
              <a href={"https://www.iamaible.com"}>www.iamaible.com</a>
              <span>{" for any new projects. Please contact your customer success team or "}</span>
              <a href={`mailto:${emailAddress}?subject=${emailSubject}&body=${emailBody}`}>{emailAddress}</a>
              <span>{" if you need help recreating your existing projects and datasets on the new server."}</span>
            </div>
            <div className={styles.warningContent}>
              <span>
                {
                  "The latest update to Aible includes many new features and brand new products - Sense, Explore, and Optimize. Existing customers get all of the relevant features at no additional costs, but this big shift requires you to conduct a one-time migration to set up. This migration should take no more than an hour and our customer success team will work closely with you to help."
                }
              </span>
            </div>
          </div>
          {this.renderFooter()}
        </div>
      </div>
    );
  }

  renderPROD() {
    return (
      <div className={styles.warningWrapper}>
        <div className={styles.warning}>
          <div className={styles.warningHeader}>
            <div className={styles.warningTitle}>
              {"Your account has been successfully updated with the Valentine’s Day Release."}
            </div>
            <a className={styles.warningButton} onClick={() => this.handleClose()}>
              X
            </a>
          </div>
          <div className={styles.warningBody}>
            <div className={styles.warningContent}>
              <span>{"Your previous work will continue to be accessible at "}</span>
              <a href={"https://last.iamaible.com"}>last.iamaible.com</a>
              <span>{" (if you created a project before 2/11/22 on iamaible.com)"}</span>
            </div>
            <div className={styles.warningContent}>
              <span>
                {
                  "The latest update to Aible includes many new features and brand new products  - Sense, Explore, and Optimize. Existing customers get all of the relevant features at no additional costs, but this big shift requires you to conduct a one-time migration to set up. Our customer success team will work closely with you to help. Please reach out to them at "
                }
              </span>
              <a href={`mailto:${emailAddress}?subject=${emailSubject}&body=${emailBody}`}>{emailAddress}</a>
              <span>{" with any immediate questions."}</span>
            </div>
          </div>
          {this.renderFooter()}
        </div>
      </div>
    );
  }

  renderNEXT() {
    return (
      <div className={styles.warningWrapper}>
        <div className={styles.warning}>
          <div className={styles.warningHeader}>
            <Icon type="warning" />
            <div className={styles.warningTitle}>{"Access the Latest Updates at IamAible.com"}</div>
            <a className={styles.warningButton} onClick={() => this.handleClose()}>
              X
            </a>
          </div>
          <div className={styles.warningBody}>
            <div className={styles.warningContent}>
              <span>{"We strongly encourage you to switch to "}</span>
              <a href={"https://www.iamaible.com"}>www.iamaible.com</a>
              <span>
                {
                  " to access the latest Aible updates as they will take longer to be introduced on this server. Your account will already work at "
                }
              </span>
              <a href={"https://www.iamaible.com"}>www.iamaible.com</a>
              <span>
                {
                  ", but you will need to reconnect to your cloud accounts.  Your existing work will continue to be accessible on this server."
                }
              </span>
            </div>
            <div className={styles.warningContent}>
              <span>
                {
                  "Aible has updated our product portfolio with tons of brand new features and brand new products - Sense, Explore, and Optimize. Existing customers get all of the relevant features at no additional cost, but this big shift requires you to conduct a one-time manual migration. Our customer success team will work closely with you to help. Please feel free to reach out to "
                }
              </span>
              <a href={`mailto:${emailAddress}?subject=${emailSubject}&body=${emailBody}`}>{emailAddress}</a>
              <span>{" with any questions."}</span>
            </div>
          </div>
          {this.renderFooter()}
        </div>
      </div>
    );
  }

  render() {
    if (this.state.isHidden || CURR_MESSAGE_TYPE === MESSAGE_TYPES.NONE || !isEnabled("server-warning")) {
      return <React.Fragment />;
    }

    switch (CURR_MESSAGE_TYPE) {
      case MESSAGE_TYPES.LAST:
        return this.renderLAST();
      case MESSAGE_TYPES.PROD:
        return this.renderPROD();
      case MESSAGE_TYPES.NEXT:
        return this.renderNEXT();
    }

    return this.renderPROD();
  }
}
